import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';

import { Overlay } from '../UIComponents';
import '../../assets/fonts/css/cc_card.css';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '14px',
        color: '#2e3b4e',
        letterSpacing: '0.025em',
        fontFamily: 'Open Sans, sans-serif',
        '::placeholder': {
          color: '#6a6a6a',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

const cardBrandToFaClass = {
  visa: 'icon-cc-visa-brands-solid',
  mastercard: 'icon-cc-mastercard-brands-solid',
  amex: 'icon-cc-amex-brands-solid',
  discover: 'icon-cc-discover-brands-solid',
  diners: 'icon-cc-diners-club-brands-solid',
  jcb: 'icon-cc-jcb-brands-solid',
  unknown: 'icon-credit-card-solid',
};

class AddCardModal extends React.Component {
  constructor() {
    super();

    this.state = {
      cardName: '',
      cardBrand: 'unknown',
      errors: {},
      isSaving: false,
    };

    this.onCardNameChange = this.onCardNameChange.bind(this);
    this.onCardNumberChange = this.onCardNumberChange.bind(this);
    this.onCardExpiryChange = this.onCardExpiryChange.bind(this);
    this.onCardCVCChange = this.onCardCVCChange.bind(this);
    this.onCardSave = this.onCardSave.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visibility === false) {
      this.setState({
        isSaving: false,
      });
    }
  }

  onCardNameChange(event) {
    this.setState({
      cardName: event.target.value,
    });
  }

  onCardNumberChange(event) {
    this.setState({
      cardBrand: event.brand || 'unknown',
      errors: this.getValidationErrors('cardNumber', event.error),
    });
  }

  onCardExpiryChange(event) {
    this.setState({
      errors: this.getValidationErrors('cardExpiry', event.error),
    });
  }

  onCardCVCChange(event) {
    this.setState({
      errors: this.getValidationErrors('cardCVC', event.error),
    });
  }

  onCardSave(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.stripe
          .createToken({ name: this.state.cardName })
          .then(({ token, error }) => {
            if (error) {
              console.log('err', error);
            } else {
              this.props.addCard({ tokenId: token.id });
            }
          });
      },
    );
  }

  getValidationErrors(fieldName, error) {
    const errors = Object.assign({}, this.state.errors);

    if (error) {
      errors[fieldName] = {
        message: error.message,
      };
    } else if (errors[fieldName]) {
      delete errors[fieldName];
    }

    return errors;
  }

  render() {
    const { visibility, onClose, isEdit } = this.props;

    const onContentClick = (e) => {
      return e.stopPropagation();
    };

    const contentProps = {
      onClick: onContentClick,
    };

    return (
      <div className={classnames('modal', { open: visibility })}>
        <Overlay onOverlayClick={onClose}>
          <div className="modal__content add-card" {...contentProps}>
            <h4>{isEdit ? 'EDIT CARD' : 'ADD NEW CARD'}</h4>
            <form onSubmit={this.onCardSave}>
              <div className="add-card__name">
                <input
                  type="text"
                  name="name"
                  placeholder="Name on card"
                  onChange={this.onCardNameChange}
                  value={this.state.cardName}
                />
                <span className="message--small message--error">
                  {this.state.errors.cardName &&
                    this.state.errors.cardName.message}
                </span>
              </div>
              <div className="add-card__number">
                <span
                  className={classnames(
                    'cc-brand',
                    cardBrandToFaClass[this.state.cardBrand]
                  )}
                />
                <CardNumberElement
                  placeholder="Card Number"
                  onChange={this.onCardNumberChange}
                  {...createOptions()}
                />
                <span className="message--small message--error">
                  {this.state.errors.cardNumber &&
                    this.state.errors.cardNumber.message}
                </span>
              </div>
              <div className="add-card__info">
                <div className="add-card__info__expiry">
                  <CardExpiryElement
                    onChange={this.onCardExpiryChange}
                    {...createOptions()}
                  />
                  <span className="message--small message--error">
                    {this.state.errors.cardExpiry &&
                      this.state.errors.cardExpiry.message}
                  </span>
                </div>
                <div className="add-card__info__cvc">
                  <CardCVCElement
                    onChange={this.onCardCVCChange}
                    {...createOptions()}
                  />
                  <span className="message--small message--error">
                    {this.state.errors.cardCVC &&
                      this.state.errors.cardCVC.message}
                  </span>
                </div>
              </div>
              <div className="add-card__actions">
                <button
                  type="submit"
                  className="btn btn--primary btn--sm"
                  disabled={this.state.isSaving}
                >
                  {this.state.isSaving ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </Overlay>
      </div>
    );
  }
}

AddCardModal.defaultProps = {
  addCard: () => {},
  onClose: () => {},
  visibility: false,
  isEdit: false,
  stripe: {
    createToken: () => {},
  },
};

AddCardModal.propTypes = {
  addCard: PropTypes.func,
  onClose: PropTypes.func,
  visibility: PropTypes.bool,
  isEdit: PropTypes.bool,
  stripe: PropTypes.shape({
    createToken: PropTypes.func,
  }),
};

export default injectStripe(AddCardModal);
